<template>
	<auth-container :page="page">
		<h2 class="mb-4">Create New HUB Contractor</h2>

		<sr-invoice-hub-form :item="item" :invoice="invoice"></sr-invoice-hub-form>
	</auth-container>
</template>

<script>
	import SrInvoiceHubForm from './SrInvoiceHubForm.vue';
	export default {
		name: 'SrInvoiceHubCreate',
		components: {
			SrInvoiceHubForm
		},
		data() {
			return {
				page: {
					errors: [],
					loading: false,
					showLogin: false
				},
				item: {
					workOrderInvoiceId: null,
					contractor: null,
					vidEin: null,
					amount: 0,
					notes: null
				},
				invoice: null
			}
		},
		async created() {
			await this.get();
		},
		watch: {
			'$route': 'get'
		},
		methods: {
			async get() {
				this.page.loading = true;
				this.page.errors = [];

				if (!this.isNullOrEmpty(this.$route.query.invoiceId)) {
					try {
						const response = await this.$http.get(`srworkorderinvoices/getname/${this.$route.query.invoiceId}`, this.getTokenHeader());
						this.invoice = response.data;
						this.item.workOrderInvoiceId = response.data.id;
					} catch (error) {
						if (this.isApiUnauthorized(error)) this.page.showLogin = true;
						else this.page.errors = this.logError(error);
					}
				}

				this.page.loading = false;
			}
		}
	}
</script>